<template>
  <router-view name="menu-client-apps" />
</template>

<script>
export default {
  name: 'RouterPassThroughMenuClientApps',
}
</script>

<style scoped></style>
